import React, { useMemo } from "react";
import ScheduleEntryBox from "./ScheduleEntryBox";
import { useSharedSelector } from "../../../store/SharedProvider";
import { selectMissions, selectRooms, selectSelectedFloor } from "../../../store/room/room-selectors";
import { selectScheduleEntries } from "../../../store/room/scheduler/scheduler-selectors";

const Schedules: React.FC = () => {
  const rooms = useSharedSelector((state) => selectRooms(state));
  const missions = useSharedSelector((state) => selectMissions(state));
  const scheduleEntries = useSharedSelector((state) => selectScheduleEntries(state));
  const selectedFloor = useSharedSelector((state) => selectSelectedFloor(state));

  const floorMissions = useMemo(
    () => missions.filter((m) => rooms.filter((r) => r.floorId === selectedFloor?.id).some((r) => r.id === m.room)),
    [missions, rooms, selectedFloor?.id]
  );

  return (
    <React.Fragment>
      {scheduleEntries.data
        .filter((se) => se.isTemporary || floorMissions.some((m) => m.id === se.scheduleEntry.missionId))
        .map((se) => (
          <ScheduleEntryBox
            schedule={se.scheduleEntry}
            key={se.scheduleEntry.id}
            isTemporary={se.isTemporary}
            hasBeenEdited={se.hasBeenEdited}
            isOverlapping={se.isOverlapping}
            wasDragged={se.wasDragged}
            mission={missions.find((m) => m.id === se.scheduleEntry.missionId)}
          />
        ))}
    </React.Fragment>
  );
};

export default Schedules;
